// Specify Manually
// dev
// export const SERVER_URL='http://localhost:8080/';
// prod
// export const SERVER_URL='https://tdmpmedia-backend.onrender.com/';

export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
